export const mockUsuarios = [
  {
    id: 1,
    userId: "user-admin",
    nome: "Gabriel Sotero",
    email: "gabriel@netexperts.com.br",
    cpf: "52998224725",
    telefone: "11987654321",
    role: "ADMIN",
    bloqueado: false,
    dois_fatores: true,
    criado_em: "2026-01-10 09:00:00",
  },
  {
    id: 2,
    userId: "user-mariana",
    nome: "Mariana Reis",
    email: "mariana@netexperts.com.br",
    cpf: "39053344705",
    telefone: "11976543210",
    role: "USER",
    bloqueado: false,
    dois_fatores: true,
    criado_em: "2026-03-02 11:20:00",
  },
  {
    id: 3,
    userId: "user-pedro",
    nome: "Pedro Santos",
    email: "pedro@netexperts.com.br",
    cpf: "11144477735",
    telefone: "21988776655",
    role: "USER",
    bloqueado: false,
    dois_fatores: false,
    criado_em: "2026-05-18 15:40:00",
  },
  {
    id: 4,
    userId: "user-helena",
    nome: "Helena Souza",
    email: "helena@netexperts.com.br",
    cpf: "88621577953",
    telefone: "31999887766",
    role: "USER",
    bloqueado: true,
    dois_fatores: false,
    criado_em: "2026-06-01 08:15:00",
  },
  {
    id: 5,
    userId: "user-ana",
    nome: "Ana Costa",
    email: "ana.costa@exemplo.com",
    cpf: "15350946056",
    telefone: "11912345678",
    role: "SIGNER",
    bloqueado: false,
    dois_fatores: true,
    criado_em: "2026-04-12 10:00:00",
  },
];
